/*
 * MainRouter.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 03 2023 mys Company
 */

import { Route, Routes } from 'react-router'
import Dashboard from '../../modules/dashboard/page/Dashboard'
import NotFound404 from '../../modules/general/404'
import MainLayout from '../../modules/general/MainLayout'
import { localization } from '../localize/localizable'
import AppConfigRoute from '../../modules/appConfig/routes/AppConfigRoute'
import OtpPage from '../../modules/account/pages/OtpPage'
import LoginPage from '../../modules/account/pages/LoginPage'
import ArticleRoute from '../../modules/article/routes/ArticleRoute'
import GroupRoute from '../../modules/group/routes/GroupRoute'
import AdvertisementRoute from '../../modules/advertisement/routes/AdvertisementRoute'
import UserRelationRoute from '../../modules/userRelation/routes/UserRelationRoute'
import UserSocialRoute from '../../modules/userSocial/routes/UserSocialRoute'
import UserRoute from '../../modules/user/routes/UserRoute'
import UserContactRoute from '../../modules/userContact/routes/UserContactRoute'
import TaskRoute from '../../modules/task/routes/TaskRoute'
import TicketRoute from '../../modules/ticket/routes/TicketRoute'
import TagRoute from '../../modules/tag/routes/TagRoute'
import SourcePropertyRoute from '../../modules/sourceProperty/routes/SourcePropertyRoute'
import SourceCategoryRoute from '../../modules/sourceCategory/routes/SourceCategoryRoute'
import SliderRoute from '../../modules/slider/routes/SliderRoute'
import SiteSocialRoute from '../../modules/siteSocial/routes/SiteSocialRoute'
import RelatedLocationRoute from '../../modules/relatedLocation/routes/RelatedLocationRoute'
import PropertyRoute from '../../modules/property/routes/PropertyRoute'
import ProductRoute from '../../modules/product/routes/ProductRoute'
import PlayListRoute from '../../modules/playList/routes/PlayListRoute'
import PermissionRoute from '../../modules/permission/routes/PermissionRoute'
import PaymentRoute from '../../modules/payment/routes/PaymentRoute'
import OrderDetailRoute from '../../modules/orderDetail/routes/OrderDetailRoute'
import OrderRoute from '../../modules/order/routes/OrderRoute'
import NotificationRoute from '../../modules/notification/routes/NotificationRoute'
import NewsTypeRoute from '../../modules/newsType/routes/NewsTypeRoute'
import NewsLetterRoute from '../../modules/newsLetter/routes/NewsLetterRoute'
import NewsRoute from '../../modules/news/routes/NewsRoute'
import MessageRoute from '../../modules/message/routes/MessageRoute'
import MenuRoute from '../../modules/menu/routes/MenuRoute'
import LocationTypeRoute from '../../modules/locationType/routes/LocationTypeRoute'
import LocationPropertyRoute from '../../modules/locationProperty/routes/LocationPropertyRoute'
import LocationRoute from '../../modules/location/routes/LocationRoute'
import LiveRoute from '../../modules/live/routes/LiveRoute'
import HomeTypeRoute from '../../modules/homeType/routes/HomeTypeRoute'
import HomeRoute from '../../modules/home/routes/HomeRoute'
import HeaderRoute from '../../modules/header/routes/HeaderRoute'
import FooterRoute from '../../modules/footer/routes/FooterRoute'
import FileRoute from '../../modules/file/routes/FileRoute'
import FavoriteRoute from '../../modules/favorite/routes/FavoriteRoute'
import CommentRoute from '../../modules/comment/routes/CommentRoute'
import ExpertTypeRoute from '../../modules/expertType/routes/ExpertTypeRoute'
import ExpertRoute from '../../modules/expert/routes/ExpertRoute'
import CityRoute from '../../modules/city/routes/CityRoute'
import CategoryRoute from '../../modules/category/routes/CategoryRoute'
import BrandRoute from '../../modules/brand/routes/BrandRoute'
import BlogRoute from '../../modules/blog/routes/BlogRoute'
import ActivationCodeRoute from '../../modules/activationCode/routes/ActivationCodeRoute'
import FaqRoute from '../../modules/faq/routes/FaqRoute'
import ContactUsRoute from '../../modules/contactUs/routes/ContactUsRoute'
import StaticPageRoute from '../../modules/staticPage/routes/StaticPageRoute'

const MainRouter = () => {
    return (
        <div dir={localization.getLanguage() === 'fa-IR' ? 'rtl' : 'ltr'}>
            <Routes>
                <Route path="/adminpanel/*" element={<MainLayout />}>
                    <Route path="dashboard" element={<Dashboard />} />

                    {/* <Route path="aboutus">
                        <Route index element={<AboutUses />} />
                        <Route path=":id" element={<AboutUs />} />
                    </Route> */}

                    {ContactUsRoute}
                    {StaticPageRoute}
                    {ActivationCodeRoute}
                    {AdvertisementRoute}
                    {AppConfigRoute}
                    {ArticleRoute}
                    {BlogRoute}
                    {BrandRoute}
                    {CategoryRoute}
                    {CityRoute}
                    {CommentRoute}
                    {ExpertRoute}
                    {ExpertTypeRoute}
                    {FaqRoute}
                    {FavoriteRoute}
                    {FileRoute}
                    {FooterRoute}
                    {HeaderRoute}
                    {HomeRoute}
                    {HomeTypeRoute}
                    {LiveRoute}
                    {LocationRoute}
                    {LocationPropertyRoute}
                    {LocationTypeRoute}
                    {MenuRoute}
                    {MessageRoute}
                    {NewsRoute}
                    {NewsLetterRoute}
                    {NewsTypeRoute}
                    {NotificationRoute}
                    {OrderRoute}
                    {OrderDetailRoute}
                    {PaymentRoute}
                    {PermissionRoute}
                    {PlayListRoute}
                    {ProductRoute}
                    {PropertyRoute}
                    {RelatedLocationRoute}
                    {SiteSocialRoute}
                    {SliderRoute}
                    {SourceCategoryRoute}
                    {SourcePropertyRoute}
                    {StaticPageRoute}
                    {TagRoute}
                    {TicketRoute}
                    {TaskRoute}
                    {UserRoute}
                    {UserContactRoute}
                    {UserRelationRoute}
                    {UserSocialRoute}
                    {GroupRoute}
                </Route>

                <Route path="/" element={<LoginPage />} />
                <Route path="/otp" element={<OtpPage />} />
                <Route path="*" element={<NotFound404 />} />
            </Routes>
        </div>
    )
}

export default MainRouter
